module.exports = "<p>\n  donatefund works!\n</p>\n"